import "./Patient.css";
import { useState, useEffect } from "react";

const Patient = (props) => {
  const [data, setData] = useState("");
  const [selectedIdx, setselectedIdx] = useState("");
  useEffect(() => {
    setData(props.getData());
  }, [data, props]);
  console.log("patientData", data);
  return (
    <div className="patientContainer">
      {data?.objects?.map((item, index) => (
        <p
          key={index}
          className={`${
            index === data?.objects?.length - 1 ? "lastRow" : ""
          } cursor-pointer name ${selectedIdx === index ? "active" : ""}`}
          onClick={() => {
            props.setResourceListData(item);
            setselectedIdx(index);
          }}
        >
          {item.resource.name[0].given[0] +
            " " +
            item?.resource?.name[0]?.family +
            " " +
            (item?.resource?.gender ? item.resource.gender + " " : "") +
            (item.resource.birthDate ? item.resource.birthDate + " " : "")}
        </p>
      ))}
    </div>
  );
};

export default Patient;
